// src/TeamMember.js

import React from "react";
import "./TeamMember.css";

const TeamMember = ({ name, role, image }) => {
  return (
    <div className="team-member">
      <div className="image-container">
        <img src={image} alt={`${name}'s profile`} />
      </div>
      <div className="info">
        <h3>{name}</h3>
        <p>{role}</p>
      </div>
    </div>
  );
};

export default TeamMember;
